export function getLayoutStyle(isResponsiveLayout: boolean): string {
  return isResponsiveLayout ? 'columns' : 'columns_mobile';
}
